'use client';

import classNames from 'classnames';
import { FC, PropsWithChildren, useState } from 'react';

import { IconQuestionMarkEmpty } from 'src/general/Icons/IconQuestionMarkEmpty';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';
import { BasicModal } from '../BasicModal/BasicModal';
import { Button } from '../Button/Button';
import { Shade } from '../Shade/Shade';
import styles from './HelperModal.module.scss';

type Props = {
  entryId: string;
  title: string;
  modalTitle: string;
  className?: string;
  closeButton?: boolean;
  iconOnly?: boolean;
};

export const HelperModal: FC<PropsWithChildren<Props>> = ({
  entryId,
  title,
  modalTitle,
  children,
  className,
  closeButton,
  iconOnly,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onOpen = () => {
    setIsOpen(true);
    pushToDataLayer({
      event: `open_helper_modal`,
      value: entryId,
      label: title,
    });
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className={classNames(styles.trigger, 'shade_container', { [styles.iconOnly]: iconOnly })}
        onClick={onOpen}
        type="button"
        data-testid="HelperModal-trigger"
      >
        <Shade />
        <span className={styles.triggerContent}>
          <IconQuestionMarkEmpty />
          {!iconOnly ? title : ''}
        </span>
      </button>
      <BasicModal
        id={entryId}
        isOpen={isOpen}
        onClose={onClose}
        title={modalTitle}
        className={classNames(styles.modal, className)}
        footer={closeButton && <Button onClick={onClose}>Close</Button>}
      >
        {children}
      </BasicModal>
    </>
  );
};
